// // import React from 'react';
// // import { FaHandshake, FaTools } from "react-icons/fa";
// // import { HiLightBulb } from "react-icons/hi";
// // import '../styles/howitworks.scss';

// // const ProcessStep = ({ number, Icon, title, description }) => (
// //     <div className="process-step">
// //         <div className="step-icon-container">
// //             <div className="step-circle">
// //                 <Icon className="step-icon" />
// //                 <span className="step-number">{number}</span>
// //             </div>
// //         </div>
// //         <h3 className="step-title">{title}</h3>
// //         <p className="step-description">{description}</p>
// //     </div>
// // );

// // const HowItWorks = () => (
// //     <section className="how-it-works-section">
// //         <div className="container">
// //             <h2 className="section-heading">How We Bring Your Custom Vision to Life</h2>
// //             <p className="section-subheading">
// //                 Artiza connects your unique design ideas with the best local artisans for bespoke furniture and decor.
// //             </p>

// //             <div className="process-grid">
// //                 <ProcessStep
// //                     number="1"
// //                     Icon={HiLightBulb}
// //                     title="Share Your Idea"
// //                     description="Submit a sketch, a mood board, or simply a detailed description of what you envision."
// //                 />
// //                 <ProcessStep
// //                     number="2"
// //                     Icon={FaHandshake}
// //                     title="Get Matched"
// //                     description="Our team pairs your project with vetted artisans whose skills and materials align with your requirements."
// //                 />
// //                 <ProcessStep
// //                     number="3"
// //                     Icon={FaTools}
// //                     title="See It Created"
// //                     description="Work directly with the artisan on the details, track the crafting process, and receive your unique piece."
// //                 />
// //             </div>

// //             <div className="cta-wrapper">
// //                 <a href="/login" className="cta-button">
// //                     Start Your Custom Project Today
// //                 </a>
// //             </div>
// //         </div>
// //     </section>
// // );

// // export default HowItWorks;




// // src/components/HowItWorks.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaHandshake, FaTools, FaArrowRight, FaQuoteLeft } from 'react-icons/fa';
// import { HiLightBulb } from 'react-icons/hi';
// import '../styles/howitworks.scss';

// const STEPS = [
//   {
//     number: '1',
//     Icon: HiLightBulb,
//     title: 'Post your project',
//     tagline: 'Start with what you already have',
//     description:
//       'Whether it is a napkin sketch, a Pinterest board, or just a paragraph describing what you want — that is enough. Write up your brief, set your budget and rough timeline, and publish it. Takes under two minutes.',
//     bullets: [
//       'Photos, sketches, or a written brief',
//       'Set your own budget & deadline',
//       'Published in under 2 minutes',
//     ],
//   },
//   {
//     number: '2',
//     Icon: FaHandshake,
//     title: 'Get matched with an artisan',
//     tagline: 'The right hands for your piece',
//     description:
//       'Verified artisans who specialize in exactly what you need will send you proposals. Compare their portfolios, ratings, and quotes side-by-side, chat with the makers directly, and lock in a price you both feel good about.',
//     bullets: [
//       'Matched by craft, not by chance',
//       'Compare portfolios, ratings & quotes',
//       'Chat before you commit',
//     ],
//   },
//   {
//     number: '3',
//     Icon: FaTools,
//     title: 'Watch it take shape',
//     tagline: 'From workshop to your door',
//     description:
//       'Follow your piece as it comes together — cut, joined, sanded, finished. Your artisan sends milestone photos as each stage is completed, and once you approve the final one, your piece ships to your door.',
//     bullets: [
//       'Milestone photo updates',
//       'Approve each stage as it lands',
//       'Kenya-wide delivery',
//     ],
//   },
// ];

// const HowItWorks = () => (
//   <section className="hiw-section" id="how">
//     {/* Decorative background rings + glow */}
//     <span className="hiw-deco hiw-deco-ring" />
//     <span className="hiw-deco hiw-deco-glow" />

//     <div className="hiw-wrap">
//       {/* ================= HEADER ================= */}
//       <header className="hiw-head">
//         <span className="hiw-eyebrow">
//           <span className="hiw-eyebrow-dot" />
//           How it works
//         </span>

//         <h2 className="hiw-title">
//           Three steps from
//           <br />
//           <em>vision</em> to <em>craft</em>
//         </h2>

//         <p className="hiw-sub">
//           Artiza brings the workshop to you — from the first sketch to the
//           final delivery, everything happens in one transparent flow.
//         </p>
//       </header>

//       {/* ================= TIMELINE ================= */}
//       <ol className="hiw-timeline">
//         {STEPS.map(({ number, Icon, title, tagline, description, bullets }, i) => (
//           <li className="hiw-step" key={number}>
//             {/* --- Marker column --- */}
//             <div className="hiw-marker">
//               <span className="hiw-marker-node">
//                 <Icon />
//               </span>
//               <span className="hiw-marker-number">{number}</span>
//               {i < STEPS.length - 1 && <span className="hiw-marker-line" />}
//             </div>

//             {/* --- Content column --- */}
//             <div className="hiw-content">
//               <div className="hiw-content-head">
//                 <span className="hiw-step-tag">Step {number}</span>
//                 <span className="hiw-step-tagline">{tagline}</span>
//               </div>

//               <h3 className="hiw-content-title">{title}</h3>
//               <p className="hiw-content-text">{description}</p>

//               <ul className="hiw-bullets">
//                 {bullets.map((b, bi) => (
//                   <li key={bi}>
//                     <span className="hiw-bullet-dot" />
//                     {b}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </li>
//         ))}
//       </ol>

//       {/* ================= CTA STRIP ================= */}
//       <div className="hiw-cta-strip">
//         <div className="hiw-cta-quote">
//           <FaQuoteLeft />
//           <div>
//             <p>
//               The whole process felt like commissioning a friend.
//               From sketch to delivery in 3 weeks.
//             </p>
//             <span>— Grace M. · Nairobi</span>
//           </div>
//         </div>

//         <div className="hiw-cta-actions">
//           <Link to="/login" className="hiw-btn hiw-btn-solid">
//             Start a project
//             <FaArrowRight />
//           </Link>
//           <Link to="/browse-project-requests" className="hiw-btn hiw-btn-ghost">
//             See open projects
//           </Link>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// export default HowItWorks;




// src/components/HowItWorks.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHandshake, FaTools, FaArrowRight, FaQuoteLeft } from 'react-icons/fa';
import { HiLightBulb } from 'react-icons/hi';
import '../styles/howitworks.scss';

const STEPS = [
  {
    number: '1',
    Icon: HiLightBulb,
    title: 'Post your project',
    tagline: 'Start with what you already have',
    description:
      'Whether it is a napkin sketch, a Pinterest board, or just a paragraph describing what you want — that is enough. Write up your brief, set your budget and rough timeline, and publish it. Takes under two minutes.',
    bullets: [
      'Photos, sketches, or a written brief',
      'Set your own budget & deadline',
      'Published in under 2 minutes',
    ],
  },
  {
    number: '2',
    Icon: FaHandshake,
    title: 'Get matched with an artisan',
    tagline: 'The right hands for your piece',
    description:
      'Verified artisans who specialize in exactly what you need will send you proposals. Compare their portfolios, ratings, and quotes side-by-side, chat with the makers directly, and lock in a price you both feel good about.',
    bullets: [
      'Matched by craft, not by chance',
      'Compare portfolios, ratings & quotes',
      'Chat before you commit',
    ],
  },
  {
    number: '3',
    Icon: FaTools,
    title: 'Watch it take shape',
    tagline: 'From workshop to your door',
    description:
      'Follow your piece as it comes together — cut, joined, sanded, finished. Your artisan sends milestone photos as each stage is completed, and once you approve the final one, your piece ships to your door.',
    bullets: [
      'Milestone photos at each stage',
      'Approve every step as it lands',
      'Kenya-wide delivery',
    ],
  },
];

const HowItWorks = () => (
  <section className="hiw-section" id="how">
    {/* Decorative background */}
    <span className="hiw-deco hiw-deco-ring" />
    <span className="hiw-deco hiw-deco-glow" />

    <div className="hiw-wrap">
      {/* ================= HEADER ================= */}
      <header className="hiw-head">
        <span className="hiw-eyebrow">
          <span className="hiw-eyebrow-dot" />
          How it works
        </span>

        <h2 className="hiw-title">
          Three steps from
          <br />
          <em>vision</em> to <em>craft</em>
        </h2>

        <p className="hiw-sub">
          Artiza brings the workshop to you — from the first sketch to the
          final delivery, everything happens in one transparent flow.
        </p>
      </header>

      {/* ================= RADIAL CIRCLE (desktop) ================= */}
      <div className="hiw-circle" role="list">
        {/* Center hub */}
        <div className="hiw-circle-hub">
          <span className="hub-icon">
            <HiLightBulb />
          </span>
          <strong>Artiza</strong>
          <span className="hub-sub">Workshop flow</span>
        </div>

        {/* Connecting dashed ring */}
        <div className="hiw-circle-ring" aria-hidden="true" />

        {/* Step nodes positioned on the ring */}
        {STEPS.map(({ number, Icon, title, tagline, description, bullets }) => (
          <div
            key={number}
            className={`hiw-circle-node hiw-circle-node-${number}`}
            role="listitem"
          >
            <div className="hiw-node-marker">
              <Icon />
              <span className="hiw-node-number">{number}</span>
            </div>

            <div className="hiw-node-card">
              <span className="hiw-node-tag">Step {number}</span>
              <h3 className="hiw-node-title">{title}</h3>
              <p className="hiw-node-tagline">{tagline}</p>
              <p className="hiw-node-text">{description}</p>

              <ul className="hiw-node-bullets">
                {bullets.map((b, bi) => (
                  <li key={bi}>
                    <span className="hiw-bullet-dot" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* ================= VERTICAL LIST (mobile) ================= */}
      <ol className="hiw-timeline-mobile">
        {STEPS.map(({ number, Icon, title, tagline, description, bullets }) => (
          <li className="hiw-mstep" key={number}>
            <div className="hiw-mstep-marker">
              <Icon />
              <span className="hiw-mstep-number">{number}</span>
            </div>
            <div className="hiw-mstep-content">
              <span className="hiw-node-tag">Step {number}</span>
              <h3 className="hiw-node-title">{title}</h3>
              <p className="hiw-node-tagline">{tagline}</p>
              <p className="hiw-node-text">{description}</p>
              <ul className="hiw-node-bullets">
                {bullets.map((b, bi) => (
                  <li key={bi}>
                    <span className="hiw-bullet-dot" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ol>

      {/* ================= CTA STRIP ================= */}
      {/* <div className="hiw-cta-strip">
        <div className="hiw-cta-quote">
          <FaQuoteLeft />
          <div>
            <p>
              The whole process felt like commissioning a friend.
              From sketch to delivery in 3 weeks.
            </p>
            <span>— Grace M. · Nairobi</span>
          </div>
        </div>

        <div className="hiw-cta-actions">
          <Link to="/login" className="hiw-btn hiw-btn-solid">
            Start a project
            <FaArrowRight />
          </Link>
          <Link to="/browse-project-requests" className="hiw-btn hiw-btn-ghost">
            See open projects
          </Link>
        </div>
      </div> */}
    </div>
  </section>
);

export default HowItWorks;